export default {
    home:{
        'first':'chinese'
    }
}